import React from 'react';

import { useParams } from 'react-router-dom';

import { Container } from '@mui/material';

import { FlightsLogsViewerHeader } from './FlightsLogsViewerHeader';
import { FlightsLogsViewerList } from './FlightsLogsViewerList';
import { FlightsLogsViewerProvider } from './FlightsLogsViewerProvider';

export function FlightsLogsViewer() {
  const { id } = useParams<{ id: string }>();
  const reservationIds = id.split(',').filter(Boolean);

  return (
    <FlightsLogsViewerProvider>
      <Container>
        <FlightsLogsViewerHeader reservationIds={reservationIds} />
        <FlightsLogsViewerList reservationIds={reservationIds} />
      </Container>
    </FlightsLogsViewerProvider>
  );
}
